import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import {
  MultiselectBoundTemplate,
  SwitchTemplate,
  TemplateWrapper,
} from "@ryde/controls";
import {
  IImportBusStationsProps,
  IInjectedDrawerProps,
  loadingEditFormContentAtomFamily,
} from "@ryde/shared";

import { LayoutRightLoader } from "../../../right";
import { CommonDefaultDrawer } from "../common-default-drawer";
import { BaseDrawer, DrawerFormWrapperStyled, FormFooter } from "../drawer";
import { useImportBusStationsDrawer } from "./use-import-bus-stations";

export const ImportBusStationsDrawer: FC<
  IImportBusStationsProps & IInjectedDrawerProps
> = ({ onCloseDrawer, drawerNumber, title }) => {
  const { t } = useTranslation();

  const isCrudOnlyDataLoading = useRecoilValue(
    loadingEditFormContentAtomFamily("station"),
  );

  const { methods, isSaveDisabled, onSaveClick } = useImportBusStationsDrawer();

  const handleSaveClick = useEvent(() => {
    onSaveClick();
  });

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer} drawerNumber={drawerNumber}>
      <CommonDefaultDrawer
        title={title}
        onCloseDrawer={onCloseDrawer}
        Footer={
          <FormFooter
            cancelLabel={t("general.CLOSE")}
            onCancelClick={onCloseDrawer}
            onSaveClick={handleSaveClick}
            isSaveDisabled={isSaveDisabled}
          />
        }
      >
        <FormProvider {...methods}>
          {!isCrudOnlyDataLoading && (
            <DrawerFormWrapperStyled>
              <TemplateWrapper>
                <MultiselectBoundTemplate
                  name="busStationsIds"
                  formLabel={t("station.formLabel.busStationsIds")}
                  formAttributes={{
                    dropItemsSource: "busStation",
                    dropItemsDisableAdd: true,
                  }}
                />
              </TemplateWrapper>

              <TemplateWrapper>
                <SwitchTemplate
                  name="isCreateMissingAreas"
                  formLabel={t("station.formLabel.createMissingAreas")}
                />
              </TemplateWrapper>
            </DrawerFormWrapperStyled>
          )}

          {isCrudOnlyDataLoading && (
            <LayoutRightLoader>{t(`ui.LOADING_DATA`)}...</LayoutRightLoader>
          )}
        </FormProvider>
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
